
import './App.css';
import './styles/table.css'
import { createContext, Suspense, useLayoutEffect, lazy , useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { Route, Router, Routes} from 'react-router-dom';
import AppNavbar from './user/AppNavbar';
import Footer from './user/Footer';
import AnnouncementBanner from './user/AnnouncementBanner';
import ZahranStore from './user/ZahranStore';
import Years from './user/CoursesStudent/Courses';
import Profile from './user/ProfileStudent/Profile';
import Registeruser from './user/RegisterUser';
import Loginuser from './user/LoginUser';
import { useEffect } from 'react';
import ModelAnswer from './user/QuizStudent/ModelAnswerQuiz';
import axios from 'axios';
import swal from 'sweetalert';
import ScrollTopButton from './user/ScrollTop';
import Videoo from './user/Videoo';
import DisableIdm from './user/DisableIdm';
import ProfileVideos from './user/ProfileStudent/ProfileVideos';
import ChargeWallet from './user/ChargeWallet';
import PointStore from './user/PointStore';
import ResetPasswordAndMail from './user/ResetPasswordAndMail';
import Points from './user/Points';
import QrCodeComponent from './user/test';

// إضافة interceptor للـ axios لمعالجة status 429
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 429) {
      // إرجاع رسالة الخطأ من السيرفر
      const errorMessage = error.response.data?.message || 'Too Many Requests';
      swal({
        title: errorMessage,
        // text: errorMessage,
        icon: "error",
        button: "حسنا!",
      });
    }
    return Promise.reject(error);
  }
);


// import EditUserData from './user/EditUserData';
// import BooksAndCodes from './user/TechnicalSupport/BooksAndCodes';
// import LessonsInCenter from './user/TechnicalSupport/LessonsInCenter';
// import ProfileWallet from './user/ProfileStudent/ProfileWallet';
// import PayCourse from './user/PayCourse';
// import TestVideo from './user/TestVideo';
// import Loginuser from './user/LoginUser';
const Homepage = lazy(() => import('./user/Homepage'));
const Quiz = lazy(() => import('./user/QuizStudent/Quiz'));
// const Profile = lazy(() => import('./user/ProfileStudent/Profile'));
const Profilecourses = lazy(() => import('./user/ProfileStudent/Profilecourses'));
const VideoPlayer = lazy(() => import('./user/VideoStudent/VideoPlayer'));
const VideoHomework = lazy(() => import('./user/VideoStudent/VideoHomework'));
const Profilequiz = lazy(() => import('./user/ProfileStudent/Profilequiz'));
const Pay = lazy(() => import('./user/CoursesStudent/ContentCourse'));
const Courses = lazy(() => import('./user/CoursesStudent/Courses'));
const MyCourses = lazy(() => import('./user/CoursesStudent/MyCourses'));
const Homework = lazy(() => import('./user/HomeworkStudent/Homework'));
const ModelAnswerQuiz = lazy(() => import('./user/QuizStudent/ModelAnswerQuiz'));
const ModelAnswerHomework = lazy(() => import('./user/HomeworkStudent/ModelAnswerHomework'));
const StartQuiz = lazy(() => import('./user/QuizStudent/StartQuiz'));
const StartHomework = lazy(() => import('./user/HomeworkStudent/StartHomework'));
const ProfileHomework = lazy(() => import('./user/ProfileStudent/ProfileHomework'));
const StartPdf = lazy(() => import('./user/PdfStudent/Pdf'));
const PayNotLogin = lazy(() => import('./user/CoursesStudent/ContentCourseNotLogin'));
const NumberPhone = lazy(() => import('./user/TechnicalSupport/NumberPhone'));
const TopRatedQuiz = lazy(() => import('./user/QuizStudent/TopRatedQuiz'));
const BooksAndCodes = lazy(() => import('./user/TechnicalSupport/BooksAndCodes'));
const LessonsInCenter = lazy(() => import('./user/TechnicalSupport/LessonsInCenter'));
const ProfileWallet = lazy(() => import('./user/ProfileStudent/ProfileWallet'));
const PayCourse = lazy(() => import('./user/PayCourse'));
const TestVideo = lazy(() => import('./user/TestVideo'));
const EditUserData = lazy(() => import('./user/EditUserData'));
const RefCodeFawry = lazy(() => import('./user/RefCodeFawry'));




// export const ThemeContext = createContext(null);
export const BASE_URL = "https://admin.mohamed-hafez.com";
export const Image_URL = "https://admin.mohamed-hafez.com";


export const tableCustomStyles = {
  headCells: {
    style: {
      fontSize: '16px',
      fontWeight: 'bold',
      borderBottom: "3px solid #FFA500"
    },
  },
  cells: {
    style: {
      // fontSize: '17px',
      padding: '20px 15px',
    },
  },
}



function App() {

  useLayoutEffect (() =>{
    const loader = document.getElementById("loader");
    loader.classList.add("loaded");

    setTimeout(() =>{
      const loader = document.getElementById('loader');
      if (document.body.contains(loader)) {
        document.body.removeChild(loader);
      }}, 3000)
  } , []);







  const [loggedIn, setLoggedIn] = useState(0);
  const [role , setRole] = useState(2) 
    const [auth , setAuth] = useState("")
    const getToken = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoggedIn(0);
        clearToken();
      } else {
        setLoggedIn(1);
        try {
          const response = await axios.get(`${BASE_URL}/api/Auth`, {
            headers: {
              'Content-Type': 'application/json',
              "ngrok-skip-browser-warning": "any",
              Authorization: `Bearer ${token}`,
            },
          });
          setRole(response.data.role);
          setAuth(response.data); // Update auth state with response.data
          setLoggedIn(1);
        } catch (error) {
          if (error?.response?.status === 401) {
            swal({
              title: "! انتهت مدة تسجيل الدخول",
              text: "يرجى تسجيل الدخول مرة أخرى",
              icon: "warning",
              button: "حسنا!",
            });
            setLoggedIn(0);
            clearToken();
            setRole('');
          }
        }
      }
    };
    
        useEffect(() => {
          const token = localStorage.getItem('token');
          if (token) {
            getToken();
          } else {
            getToken();
          }
        }, []);




        const authed = localStorage.getItem("token");
        const roled = localStorage.getItem("sha1");
        
      const clearToken = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('sha1');
        setLoggedIn(0);
      };



  
     
    
      function NotFound() {
        return (
          <div className="not-found">
            <h1><span>404</span> - Page Not Found</h1>
          </div>
        );
      }

      const location = useLocation();

      // Check if the current route is /video/:id
      const isQuizPage = location.pathname.startsWith('/quiz/')
      const isHomeworkPage = location.pathname.startsWith('/homework/')


          
 
      
      const [isDarkMode, setIsDarkMode] = useState(
        localStorage.getItem('isDarkMode') === 'true' ? true : false
      );
    
      // Toggle dark mode
      const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
      };
    
      // Save dark mode state to local storage
      useEffect(() => {
        localStorage.setItem('isDarkMode', isDarkMode);
      }, [isDarkMode]);
    
      // Add "dark-mode" class to the body
      useEffect(() => {
        if (isDarkMode) {
          document.body.classList.add('dark-mode');
        } else {
          document.body.classList.remove('dark-mode');
        }
      }, [isDarkMode]);
    
      const darkModeStyles = {
        backgroundColor: 'black',
        // Add any additional styles for dark mode
      };

     

    

  return (
   
<div className="App">
<Suspense fallback={""}>

  <AppNavbar loggedIn={loggedIn} roled={role} auth={auth} setLoggedIn={setLoggedIn} clearToken={clearToken}  isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} style={isDarkMode ? darkModeStyles : null}/>  
  <AnnouncementBanner style={isDarkMode ? darkModeStyles : null} auth={auth} />
       
           <Routes basename="/">
    <Route path='/profile' element={!authed ? <Navigate to="/loginuser" /> : <Profile  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/registeruser' element={loggedIn ? <Navigate to="/"/> : <Registeruser style={isDarkMode ? darkModeStyles : null}/>}  />
    <Route path='/loginuser' element={loggedIn ? <Navigate to="/" /> : <Loginuser loggedIn={loggedIn} setLoggedIn={setLoggedIn} style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/' element={<Homepage loggedIn={loggedIn} setLoggedIn={setLoggedIn} auth={auth}  style={isDarkMode ? darkModeStyles : null} />} />
    <Route path='/zahran-store' element={<ZahranStore style={isDarkMode ? darkModeStyles : null} />} />
    <Route path='/pointstore' element={<PointStore loggedIn={loggedIn} setLoggedIn={setLoggedIn} auth={auth}  style={isDarkMode ? darkModeStyles : null} />} />
    <Route path='/courses/:id' element={loggedIn ? <Navigate to="/" /> : <Courses style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/course-content/:id' element={loggedIn ? <Navigate to="/" /> : <PayNotLogin  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/mycourses' element={!authed ? <Navigate to="/loginuser" /> : <MyCourses  style={isDarkMode ? darkModeStyles : null}/> }/>
    <Route path='/week/:id/subscribe' element={!authed ? <Navigate to="/loginuser" /> : <PayCourse auth={auth} setAuth={setAuth}  style={isDarkMode ? darkModeStyles : null}/> }/>
    <Route path='/course' element={!authed ? <Navigate to="/loginuser" /> : <Courses  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/contentcourse/:id' element={!authed ? <Navigate to="/loginuser" /> : <Pay  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/quiz/:id' element={!authed ? <Navigate to="/loginuser" /> : <Quiz  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/startquiz/:id' element={!authed ? <Navigate to="/loginuser" /> : <StartQuiz  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/modelanswerquiz/:id' element={!authed ? <Navigate to="/loginuser" /> : <ModelAnswerQuiz  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/TopRatedQuiz/:id' element={!authed ? <Navigate to="/loginuser" /> : <TopRatedQuiz style={isDarkMode ? darkModeStyles : null} />} />
    <Route path='/homework/:id' element={!authed ? <Navigate to="/loginuser" /> : <Homework  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/starthomework/:id' element={!authed ? <Navigate to="/loginuser" /> : <StartHomework  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/modelanswerhomework/:id' element={!authed ? <Navigate to="/loginuser" /> : <ModelAnswerHomework  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/video/:id' element={!authed ? <Navigate to="/loginuser" /> : <VideoPlayer auth={auth}  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/videohomework/:id' element={!authed ? <Navigate to="/loginuser" /> : <VideoHomework auth={auth}  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/charge-wallet' element={!authed ? <Navigate to="/loginuser" /> : <ChargeWallet  auth={auth} setAuth={setAuth}  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/startpdf/:id' element={!authed ? <Navigate to="/loginuser" /> : <StartPdf  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/profile/courses' element={!authed ? <Navigate to="/loginuser" /> : <Profilecourses  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/profile/quiz' element={!authed ? <Navigate to="/loginuser" /> : <Profilequiz style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/profile/homeworks' element={!authed ? <Navigate to="/loginuser" /> : <ProfileHomework style={isDarkMode ? darkModeStyles : null}/>}/>
    <Route path='/profile/wallet' element={!authed ? <Navigate to="/loginuser" /> : <ProfileWallet style={isDarkMode ? darkModeStyles : null}/>}/>
    <Route path='/profile/videos' element={!authed ? <Navigate to="/loginuser" /> : <ProfileVideos style={isDarkMode ? darkModeStyles : null}/>}/>
    <Route path='/payment' element={!authed ? <Navigate to="/loginuser" /> : <RefCodeFawry style={isDarkMode ? darkModeStyles : null}/>}/>
    <Route path='/numberphone' element={ <NumberPhone />} />
    <Route path='/editinfo' element={!authed ? <Navigate to="/loginuser" /> : <EditUserData auth={auth} style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/booksandcodes' element={ <BooksAndCodes  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/points' element={ <Points auth={auth}  style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='/centerschedules' element={ <LessonsInCenter  style={isDarkMode ?  darkModeStyles : null}/>} />
    <Route path='/reset-password' element={!authed ? <Navigate to="/" /> : <ResetPasswordAndMail loggedIn={loggedIn} setLoggedIn={setLoggedIn}   style={isDarkMode ? darkModeStyles : null}/>} />
    <Route path='*' element={<NotFound />} />
    <Route path='/testvideo' element={<TestVideo />}/>
    <Route path='/videoo' element={<Videoo />}/>
    <Route path='disableIDM' element={<DisableIdm />}/>
    <Route path='/test/:invoiceId' element={<QrCodeComponent />}/>
    
</Routes>


               {
            isQuizPage || isHomeworkPage
            ? null
            : <Footer style={isDarkMode ? darkModeStyles : null}/>
          }
 
{/* <IconButton onClick={toggleDarkMode} color="inherit">
  {darkMode ? 'dark' : 'light'}
</IconButton> */}

{/* <ThemeProvider theme={theme}> */}
  {/* <CssBaseline />*/}
  {/* darkMode={darkMode}
    toggleDarkMode={toggleDarkMode} */}
  
      {/* </ThemeProvider> */}


  
      </Suspense>
      
      </div>
      
  );
}

export default App;
